var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('CourseList',{attrs:{"courses":_vm.courses,"loading":_vm.fetching}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }